import { Formik, FormikHelpers } from "formik";
import { FC } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { FaFilter } from "react-icons/fa";
import yup from "app/util/yup";
import { StatusAlert } from "app/component/form/StatusAlert";
import { TestType } from "app/api/graph/types";
import { FormControlSelectTestType } from "app/component/form/control/FormControlSelectTestType";

type Props = {
    initialValues: FormValues;
    onSubmit: (values: FormValues) => void;
};

export type FormValues = {
    testType?: TestType;
};

const schema: yup.ObjectSchema<FormValues> = yup.object({
    testType: yup.mixed<TestType>().oneOf(Object.values(TestType)),
});

export const TestTypePrerequisitesTableFiltersForm: FC<Props> = (props) => {
    const onSubmit = (values: FormValues, actions: FormikHelpers<FormValues>) => {
        props.onSubmit(values);
        actions.setSubmitting(false);
    };

    return (
        <Formik validationSchema={schema} onSubmit={onSubmit} initialValues={props.initialValues}>
            {({ handleSubmit, setFieldValue, setFieldTouched, values, isSubmitting, errors, touched, status }) => (
                <Form noValidate onSubmit={handleSubmit}>
                    <StatusAlert status={status as unknown} />

                    <Form.Group className="mb-3">
                        <Form.Label>Test type</Form.Label>
                        <FormControlSelectTestType
                            name="testType"
                            value={values.testType}
                            onChange={(value) => setFieldValue("testType", value)}
                            onBlur={() => setFieldTouched("testType")}
                            isInvalid={touched.testType && !!errors.testType}
                        />
                        <Form.Control.Feedback type="invalid">{errors.testType}</Form.Control.Feedback>
                    </Form.Group>

                    <Button type="submit" disabled={isSubmitting}>
                        <FaFilter /> Filter
                    </Button>
                </Form>
            )}
        </Formik>
    );
};
